module.exports = __webpack_public_path__ + "img/recesso_futura_tec.26fc09ce.webp";